/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1904279553 — Відновлення сесії після перезавантаження */

import { ComponentType } from 'react';

import { useHydrateOrderFromUrl } from './useHydrateOrderFromUrl';

/**
 * HOC that gates a screen on `useHydrateOrderFromUrl`. Returns null while
 * the order + vm are being fetched from the URL `:id` path param, then
 * renders the wrapped component once useAppStore is populated.
 *
 * Used by every post-Connecting screen (SelectProduct, Payment*, Wait,
 * Water, Pulse, CarWash) so that browser reload doesn't leave them with
 * DEFAULT_ORDER / DEFAULT_VM.
 */
export function withOrderHydration<P extends object>(
    Body: ComponentType<P>,
): ComponentType<P> {
    const Wrapped = (props: P) => {
        const { hydrating } = useHydrateOrderFromUrl();
        if (hydrating) return null;
        return <Body {...props} />;
    };
    Wrapped.displayName = `withOrderHydration(${Body.displayName ?? Body.name ?? 'Component'})`;
    return Wrapped;
}
